import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import { getMainCategory } from "../../services/category.service";
import { useSelector } from "react-redux";

export default function MainCategoryDetails() {
  const { token } = useSelector((state) => state?.auth);
  const [mainCategory, setMainCategory] = useState(null);
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const categoryId = params.get("id");

  const fetchMainCategory = async () => {
    try {
      const res = await getMainCategory(token, categoryId);

      if (res && res.status >= 200 && res.status < 300) {
        setMainCategory(res?.data);
      } else {
        Swal.fire(
          "Error",
          "Failed to fetch category details. Please try again.",
          "error"
        );
      }
    } catch (error) {
      console.error("Error fetching main category:", error);
      Swal.fire(
        "Error",
        "An error occurred while fetching the category. Please try again later.",
        "error"
      );
    }
  };

  useEffect(() => {
    if (categoryId) {
      fetchMainCategory();
    }
  }, [categoryId]);

  return (
    <div className="content-body">
      <div className="container-fluid">
        <div className="row">
          <div className="col-xl-12 col-lg-12">
            <div className="card">
              <div className="card-header">
                <h4 className="card-title">Main Category Details</h4>
                <Link to="/main-categories">
                  <img
                    src="/assets/images/kidskart/icon/back-button.png"
                    alt="Back"
                  />
                </Link>
              </div>
              <div className="card-body">
                <div className="row">
                  {/* Category Name */}
                  <div className="col-sm-6 mb-4">
                    <h5>Category Name</h5>
                    <p>{mainCategory?.category_name || "N/A"}</p>
                  </div>

                  {/* Image */}
                  <div className="col-sm-6 mb-4">
                    <h5>Image</h5>
                    {mainCategory?.image ? (
                      <img
                        src={mainCategory?.image}
                        alt="Category"
                        className="img-thumbnail w-25"
                        style={{ width: "200px" }}
                      />
                    ) : (
                      <p>No Image Available</p>
                    )}
                  </div>

                  {/* Description */}
                  <div className="col-md-12 mb-4">
                    <h5>Description</h5>
                    <p>{mainCategory?.description || "No description provided"}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
